<template>
    <van-col :span="span" :flex="flex">
        <div class="title_col">
            <div>
                <div><span>{{title}}</span></div>
                <div><span>{{value}}</span></div>
            </div>
        </div>
    </van-col>
</template>
<script>

export default {
    name: 'myvancol',
    props: {
    span:String,
    flex:Number,
    height:String,  
    title:{
        type:String,
        default:()=>{
            return "你的标题"
        }
    },
     value:{
         type:String,
         default:()=>{
             return "0"
         }
     },
     
  },
}
</script>

<style lang="scss" scoped>
.title_col {
  background: #151D48;
  color: #fff;
  min-height: 6vw;
  margin-top: 0.5vw;
  display: flex;
  align-items: center;
  padding-left: 0.3vw;
  border-radius: 0.4vw;
  height: 95%;
  
  div div:nth-child(1){
      color: #A6ADE0;
      font-size: 0.8vw;
      padding-left: 0.8vw;
  }
  div div:nth-child(2){
      font-size: 1.5vw;
      padding-top: 0.3vw;
      padding-left: 0.8vw;
  }
}
</style>

